// XpertCreation branded dialogs — window.alert override + confirm/payment helpers.
// Install once from index.js. Har purana alert() call automatically branded ho jata hai.

const LOGO = '/logo192.png';
const COLORS = { brand: '#0F6E56', danger: '#A32D2D', text: '#2C2C2A', muted: '#5F5E5A', border: '#E3E1D9' };

function detectType(msg) {
  const m = String(msg || '');
  if (m.indexOf('\u2705') === 0 || /saved|success|mubarak|live!|copied/i.test(m)) return 'success';
  if (/error|fail|invalid|nahi|required|cannot|denied|unauthorized|\u274C|\u2715/i.test(m)) return 'danger';
  return 'info';
}

function buildDialog({ title, message, type, buttons }) {
  return new Promise((resolve) => {
    const overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(20,25,23,0.55);z-index:999999;display:flex;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(2px);';

    const box = document.createElement('div');
    box.style.cssText = 'background:#fff;border-radius:16px;max-width:380px;width:100%;padding:0;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,0.3);transform:scale(0.92);opacity:0;transition:all 0.18s ease;';

    const accent = type === 'danger' ? COLORS.danger : COLORS.brand;

    const header = document.createElement('div');
    header.style.cssText = 'display:flex;align-items:center;gap:10px;padding:16px 18px 12px;';
    const img = document.createElement('img');
    img.src = LOGO;
    img.alt = 'XpertCreation';
    img.style.cssText = 'width:34px;height:34px;border-radius:9px;flex-shrink:0;';
    img.onerror = function () { this.style.display = 'none'; };
    const titleWrap = document.createElement('div');
    const t1 = document.createElement('div');
    t1.textContent = 'XpertCreation';
    t1.style.cssText = 'font-size:14px;font-weight:700;color:' + COLORS.text + ';font-family:sans-serif;';
    const t2 = document.createElement('div');
    t2.textContent = title || (type === 'danger' ? 'Attention' : type === 'success' ? 'Done' : 'Notice');
    t2.style.cssText = 'font-size:11px;color:' + accent + ';font-weight:600;font-family:sans-serif;';
    titleWrap.appendChild(t1);
    titleWrap.appendChild(t2);
    header.appendChild(img);
    header.appendChild(titleWrap);

    const bar = document.createElement('div');
    bar.style.cssText = 'height:3px;background:linear-gradient(90deg,' + accent + ',#34d399);';

    const body = document.createElement('div');
    body.style.cssText = 'padding:14px 18px;font-size:14px;line-height:1.5;color:' + COLORS.text + ';font-family:sans-serif;white-space:pre-wrap;word-break:break-word;max-height:50vh;overflow-y:auto;';
    if (typeof message === 'string') body.textContent = message;
    else if (message) body.appendChild(message);

    const foot = document.createElement('div');
    foot.style.cssText = 'display:flex;gap:8px;justify-content:flex-end;padding:0 18px 16px;';
    (buttons || [{ label: 'OK', value: true, primary: true }]).forEach((b) => {
      const btn = document.createElement('button');
      btn.textContent = b.label;
      btn.style.cssText = 'padding:9px 18px;font-size:13px;font-weight:700;border-radius:9px;cursor:pointer;font-family:sans-serif;'
        + (b.primary
          ? 'border:none;background:' + accent + ';color:#fff;'
          : 'border:1px solid ' + COLORS.border + ';background:#fff;color:' + COLORS.text + ';');
      btn.onclick = () => { close(b.value); };
      foot.appendChild(btn);
    });

    box.appendChild(bar);
    box.appendChild(header);
    box.appendChild(body);
    box.appendChild(foot);
    overlay.appendChild(box);
    document.body.appendChild(overlay);
    requestAnimationFrame(() => { box.style.transform = 'scale(1)'; box.style.opacity = '1'; });

    function close(val) {
      box.style.transform = 'scale(0.92)';
      box.style.opacity = '0';
      setTimeout(() => { overlay.remove(); resolve(val); }, 160);
    }
    overlay.onclick = (e) => { if (e.target === overlay && (buttons || []).length <= 1) close(true); };
  });
}

export function installXpertDialogs() {
  if (window.__xpertDialogInstalled) return;
  window.__xpertDialogInstalled = true;

  window.alert = function (msg) {
    const type = detectType(msg);
    buildDialog({ message: String(msg), type, buttons: [{ label: 'OK', value: true, primary: true }] });
  };

  window.xpertConfirm = function (message, opts) {
    opts = opts || {};
    return buildDialog({
      title: opts.title || 'Confirm',
      message: String(message),
      type: opts.type || 'info',
      buttons: [
        { label: opts.cancelLabel || 'Cancel', value: false, primary: false },
        { label: opts.okLabel || 'Confirm', value: true, primary: true },
      ],
    });
  };

  window.xpertPayConfirm = function (details) {
    details = details || {};
    const wrap = document.createElement('div');
    const amt = document.createElement('div');
    amt.textContent = (details.amount != null ? details.amount : '?') + ' \u03C0';
    amt.style.cssText = 'font-size:30px;font-weight:800;color:' + COLORS.brand + ';text-align:center;margin:4px 0 6px;font-family:sans-serif;';
    const memo = document.createElement('div');
    memo.textContent = details.memo || 'Pi payment';
    memo.style.cssText = 'font-size:13px;color:' + COLORS.muted + ';text-align:center;margin-bottom:6px;';
    const note = document.createElement('div');
    note.textContent = 'Aglay step par Pi Network ki official payment window khulegi.';
    note.style.cssText = 'font-size:11px;color:' + COLORS.muted + ';text-align:center;';
    wrap.appendChild(amt);
    wrap.appendChild(memo);
    wrap.appendChild(note);
    return buildDialog({
      title: 'Payment confirmation',
      message: wrap,
      type: 'info',
      buttons: [
        { label: 'Cancel', value: false, primary: false },
        { label: 'Confirm & Pay', value: true, primary: true },
      ],
    });
  };
}
